import { useState } from "react";
import api from "../../../../../services/api";
import { toastSuccess, toastError } from "../../../../../toasts";

export const useSelectFlavor = ({ groupId, flavors, onClose, selectedFlavors, getSelectedFlavors }) => {
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [isSaving, setIsSaving] = useState(false);

    const parsedFlavors = flavors
        .filter(product =>
            !selectedFlavors.find(selected => selected.IdProduto === product.Id)
        )
        .map(flavor => ({ label: flavor.Descricao, value: flavor.Id }));

    const handleSelectFlavor = async () => {
        if (!groupId) return;

        if (selectedProducts.length === 0) {
            toastError('Selecione pelo menos um sabor.');
            return;
        }

        setIsSaving(true);
        try {
            const payload = selectedProducts.map(produtoId => ({
                IdGrupo: groupId,
                IdProduto: produtoId,
            }));

            await api.post('grupo-pizzas', payload);

            toastSuccess('Sabores adicionados com sucesso!');
            getSelectedFlavors();
            setSelectedProducts([]);
            onClose();

        } catch (error) {
            console.log(error);
            toastError(error?.response?.data?.message || error?.message || 'Não foi possível salvar os sabores.');
        } finally {
            setIsSaving(false);
        }
    }

    return {
        parsedFlavors,
        selectedProducts,
        setSelectedProducts,
        handleSelectFlavor,
        isSaving
    }
}
